import email from "../../assets/images/email-setup/email-5.svg";
import RemoveAccount from "./RemoveAccount";

const AccountManagement = ({ emailConfiguration, onRemove }) => {
  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-h-full">
      <div className="d-flex align-items-center flex-column mt60">
        <img src={email} alt="" />
        <p className="tw-text-2xl tw-font-bold tw-text-[#34A853] mt30 tw-mb-1">
          Your Email is Connected!
        </p>
        <p className="tw-text-lg">
          <span className="tw-text-sub-text">Email:</span>{" "}
          <span className="tw-text-text-primary tw-text-lg tw-font-semibold">
            {emailConfiguration?.email}
          </span>{" "}
          <span className="connected-tag tw-text-sub-text">is CONNECTED</span>
        </p>
        <p className="mt20 tw-text-lg tw-text-sub-text text-center">
          Removing your email account will halt all future <br />
          email tracking and synchronization
        </p>
        <div className="d-flex align-items-center mt20" style={{ gap: 30 }}>
          <RemoveAccount onRemove={onRemove} />
        </div>
      </div>
    </div>
  );
};

export default AccountManagement;
